import styled from 'styled-components';

const TabContainer = styled.div`
	.tabLabel {
		text-transform: none;
		${props => props.theme.breakpoints.up('xs')} {
			font-size: 16px;
		}
		${props => props.theme.breakpoints.up('md')} {
			font-size: 20px;
		}
	}
	.Mui-selected {
		.tabLabel {
			font-weight: 700;
		}
	}
	.tabs-container {
		margin: 1% 0% 4% 0%;
		${props => !props.showTitleTab === false} {
			display: none;
		}
	}

	.dot-container {
		display: flex;
		align-items: center;
		justify-content: center;

		.dot {
			height: 10px;
			width: 10px;
			background: #c9e8f1;
			border-radius: 50%;
			margin-right: 3px;
		}
		.dot-selected {
			background: ${props => props.theme.label.color};
		}

		&:hover {
			cursor: pointer;
		}
	}
`;
export default TabContainer;
